import styled, { css } from 'styled-components';
import { customMedia } from 'styles/utils';

import Button from 'components/Button';
import { Checkbox } from 'libs/forms/styles';
import Input from 'components/Form/Input';

const THUMB_SIZE = 7;
const THUMB_BORDER_SIZE = 2;

export const TreeStyled = styled.nav`
  position: relative;
  z-index: 1001;
  height: 100%;
`;

export const ClipListStyled = styled.ul`
  padding: ${props => props.theme.spacing.xsmall} 0
    ${props => props.theme.spacing.xsmall} 0;
  small {
    font-size: 100%;
    margin: ${props =>
      `${props.theme.spacing.xsmall} 0 ${props.theme.spacing.xsmall}`};
    display: inline-block;
  }
  width: 100%;
  font-size: ${props => props.theme.font.size.small};
`;

export const ClipPlaneStyled = styled.li`
  padding: 0 ${props => props.theme.spacing.xsmall};
  width: 100%;
`;

export const ClipPlaneRow = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: auto 55px 40px;
  margin: ${props => props.theme.spacing.xsmall} 0
    ${props => props.theme.spacing.xsmall} 0;
`;

export const ClipLabelStyled = styled.div`
  padding-right: ${props => props.theme.spacing.small};
  font-weight: ${props => props.theme.font.weight.xbold};
  color: ${props => props.theme.color.wfGrey800};
  padding-left: 5px;
  border-left: 4px solid;
  border-color: ${props =>
    props.clipIx === 1
      ? props.theme.color.wfRed
      : props.clipIx === 2
      ? props.theme.color.wfGreen900
      : props.theme.color.wfBlue};
`;

export const ButtonsWrapper = styled.div`
  visibility: ${props => (props.active ? 'visible' : 'hidden')};
  height: 20px;
`;

export const ButtonStyled = styled(Button)`
  position: relative;
  height: 10px;
  margin-top: -5px;
  margin-left: 5px;
  &:hover {
    color: ${props =>
      props.onClick != null ? props.theme.color.wfBlue : 'inherit'};
  }
`;

export const SlideStepButtonStyled = styled(Button)`
  position: relative;
  align-items: center;
  color: ${props =>
    props.disabled ? props.theme.color.wfGrey400 : props.theme.color.wfBlack};
  &:hover {
    color: ${props =>
      props.onClick != null ? props.theme.color.wfBlue : 'inherit'};
    cursor: ${props => (props.onClick != null ? 'pointer' : 'default')};
  }
`;

export const SliderButtonStyled = styled(Button)`
  color: ${props => props.theme.color.wfGrey800};
  &:hover {
    color: ${props => props.theme.color.wfBlack};
  }
`;

export const ClipSliderStyled = styled.li`
  opacity: ${props => !props.active && 0.2};
  width: 100%;
  position: relative;
  display: grid;
  color: ${props => props.theme.color.wfGrey};
  grid-template-columns: 38px 50px 23px 16px auto 16px 24px 24px;
`;

export const ClipRowStyled = styled.li`
  opacity: ${props => !props.active && 0.2};
  width: 100%;
  position: relative;
  display: grid;
  color: ${props => props.theme.color.wfGrey};
  float: right;
  text-align: right;
  grid-template-columns: 40px 40px auto;
  margin-bottom: 1rem;
`;

export const TextWrapper = styled.div`
  height: 24px;
  float: left;
  border-radius: ${props => props.theme.spacing.xsmall};
  border-width: 1px;
  border-style: solid;
  background: ${props => props.theme.color.wfWhite};
  border-color: ${props =>
    props.isTemp ? props.theme.color.wfOrange600 : props.theme.color.wfGrey400};
  margin: 3px 1px;
  padding: 0px 2px;
`;

export const SymbolWrapper = styled.div`
  float: left;
  padding-left: 2px;
  font-size: ${props =>
    props.small ? props.theme.font.size.xsmall : props.theme.font.size.default};
  padding-top: ${props => (props.small ? '6px' : '0px')};
`;

export const ThckValuesWrapper = styled.div`
  display: grid;
  height: 24px;
  & div {
    line-height: 17px;
  }
  & div:last-of-type {
    line-height: 15px;
  }
  & button {
    height: 24px;
    margin-top: 1px;
  }
  place-self: center;
  padding: 0 0.2rem;
  grid-template-columns: ${props =>
    props.unitLabel?.length > 0 ? '25px auto 25px' : '25px auto'};
  position: absolute;
  right: -0.2rem;
  bottom: -1px;
  border-radius: 5px;
  color: ${props => props.theme.color.wfGrey};
  border: 1px solid black;
  border-color: ${props =>
    props.highlight === 1
      ? props.theme.color.wfRed600
      : props.highlight === 0.5
      ? props.theme.color.wfOrange400
      : props.theme.color.wfWhite};
  background-color: ${props =>
    props.highlight === 1
      ? props.theme.color.wfRed100
      : props.highlight === 0.5
      ? props.theme.color.wfOrange100
      : props.theme.color.wfWhite};
`;

export const SliderWrapper = styled.div`
  float: left;
  margin-left: -10px;
  margin-right: 8px;
  cursor: pointer;
  vertical-align: bottom;
  color: #000;

  ${customMedia.lessThan('medium')`
    transform: scale(0.9);
  `};
`;

export const InputStyled = styled(Input)`
  border-color: ${props =>
    props.isGhost ? 'transparent' : props.theme.color.wfGrey200};
  border-radius: ${props =>
    props.isGhost ? '0' : props.theme.borderRadius.large};
  color: ${props =>
    props.isTemp ? props.theme.color.wfGrey800 : props.theme.color.wfBlack};
  font-size: 0.85rem;
  ${props =>
    props.isGhost &&
    `
    padding: 0;
    `}
  :focus {
    border: none;
  }
`;

const sliderThumb = css`
  width: ${THUMB_SIZE}px;
  height: ${THUMB_SIZE}px;
  border-radius: 50%;
  margin-top: -${(THUMB_SIZE + THUMB_BORDER_SIZE) / 2 + 1}px;
  background: ${props => props.theme.color.wfWhite};
  border: ${THUMB_BORDER_SIZE}px solid ${props => props.theme.color.wfBlack};
  cursor: pointer;
  box-sizing: content-box;
`;

// FIXME: Move these styles into future INPUT/slider component. Is mandatory to review and refactor css rules.
export const SliderInput = styled.input`
  width: 100%;
  height: 100%;
  margin-left: 5%;
  margin-bottom: ${props => props.theme.spacing.small};
  -webkit-appearance: none; /* Hides the slider so that custom slider can be made */
  background: transparent; /* Otherwise white in Chrome */
  box-shadow: none;
  /* Track styling for WebKit/Blink */
  &::-webkit-slider-runnable-track {
    height: 1px;
    cursor: pointer;
    background: ${props => props.theme.color.wfGrey500};
  }
  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    margin-top: -6px;
    ${sliderThumb}
  }

  /* Track styling for Firefox */
  &::-moz-range-track {
    height: 1px;
    cursor: pointer;
    background: ${props => props.theme.color.wfGrey500};
  }
  &::-moz-range-thumb {
    ${sliderThumb}
  }

  /* Track styling for IE */
  &::-ms-track {
    height: 2px;
    cursor: pointer;
    background: transparent;
    border-color: transparent;
    border-width: 16px 0;
    color: transparent;
  }

  &::-ms-fill-lower,
  &::-ms-fill-upper {
    background: ${props => props.theme.color.wfGrey500};
    border-radius: 2px;
  }

  &::-ms-thumb {
    ${sliderThumb}
    margin-top: -6px;
  }

  ${customMedia.lessThan('medium')`
    transform: scale(0.9);
  `};
`;
